module.exports = {"TXTCLI_Street_Address":{"id":"TXTCLI_Street_Address","defaultMessage":"Adresse (vej og nr.)","flags":["TRACK"],"track":"Street Address"}}